export default function InputError({ text }: { text: string | undefined }) {
  return <span className="py-1 text-destructive">{text}</span>;
}
